




































































































































import { Component, Vue } from 'vue-property-decorator';

import { UserDetail, RoleEnum, ResponseCodeEnum, DataTableRequest, TireStoringContract, EnumObject, ContractStatusEnum, Warehouse, InputError, Location } from '@/models';
import { loginService, tireStoringContractService, warehouseService, toastService, locationService,tireStoringInfoService } from '@/services';

import { SearchContractDataTableSetting, FieldEnum, ActionEnum } from '@/components/shared';
import DataTable from '@/components/shared/table/DataTable.vue';
import QrcodeReader from '@/components/shared/qrcode/QrcodeReader.vue';

import _ from 'lodash';
// @ts-ignore
import { ModelListSelect } from 'vue-search-select';
import LocationQrcodeReader from '@/components/shared/qrcode/LocationQrcodeReader.vue';


@Component({
  components: {
    DataTable,
    QrcodeReader,
    ModelListSelect,
    LocationQrcodeReader
  },
})
export default class SearchTireContractPage extends Vue {

  private isAgency: boolean = false;
  private isBtj: boolean = false;
  private showQrcodeReader: boolean = false;
  private searchByQrCode: boolean = false;
  private selectedWarehouseId: string | null = null;
  private listWarehouse: Warehouse[] = [];
  private debounceInputWarehouse = _.debounce((input) => {
    this.findWarehouse(input);
  }, 500);
  private searchText: string = '';
  private status: number = 0;
  private statusOptions: EnumObject[] = [];
  private tableFields = [
    {
      key: 'slipNo',
      label: 'view.search_tire_contract.label.contract_number',
      type: FieldEnum.FIELD_TEXT,
      sortable: false,
    },
    {
      key: 'customer.name',
      label: 'view.search_tire_contract.label.fullname',
      type: FieldEnum.FIELD_TEXT,
      sortable: false,
    },
    {
      key: 'storingDate',
      label: 'view.search_tire_contract.label.storing_date',
      type: FieldEnum.FIELD_DATE_DAYLEFT_TEXT,
      sortable: false,
    },
    {
      key: 'status',
      label: 'view.search_tire_contract.label.status',
      type: FieldEnum.FIELD_CUSTOM,
      sortable: false,
      htmlFunction: (item: TireStoringContract) => {
        return this.getStatus(item.status);
      },
    },
    {
      key: 'locationNo',
      label: 'view.search_tire_contract.label.location_no',
      type: FieldEnum.FIELD_CUSTOM_LOCATION_NO,
      sortable: false,
      thClass: 'w-25',
    },
  ];
  private getItems: Function = new Function();
  private tableSetting: SearchContractDataTableSetting = new SearchContractDataTableSetting();
  private user: UserDetail = new UserDetail();
  private showContractQrCodeReader: boolean = false;
  private showLocationQrCodeReader: boolean = false;
  private showContractConfirmModal: boolean = false;
  private showFinalConfirmModal: boolean = false;

  private scannedContractIds: string[] = [];
  private scannedLocationIds: string[] = [];
  private scannedTires: string[] = [];
  private scannedLocation: Location = new Location();

  private created() {
    // Check user role
    this.user = this.$store.state.user;
    if (this.user && this.user.role === RoleEnum.ROLE_AGENCY) {
      this.isAgency = true;
    } else if (this.user && this.user.role === RoleEnum.ROLE_BTJ_COMPANY) {
      this.isBtj = true;
    }

    if(this.user && !(this.user.role === RoleEnum.ROLE_WAREHOUSE || this.user.role === RoleEnum.ROLE_ADMIN || this.user.role === RoleEnum.ROLE_COMPANY_ADMIN)) {
      const tableFieldLocationNo = this.tableFields.find((item: any) => item.key === 'locationNo');
      if(tableFieldLocationNo) {
        tableFieldLocationNo.type = FieldEnum.FIELD_TEXT;
        tableFieldLocationNo.thClass = '';
      }
    }

    tireStoringContractService.getContractStatus()
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          this.statusOptions = res.data.data
            // Don't show contract with status Completed
            .filter((option) => option.value !== 9)
            .map((option) => {
              if (option.text) {
                option.text = this.$t(option.text).toString();
              }
              return option;
            });
        }
      });
    this.getItems = ((request: DataTableRequest) => {
      const errors: InputError[] = [
        { field: 'rackLocation', isError: undefined, message: [] },
        { field: 'columnLocation', isError: undefined, message: [] },
        { field: 'rowLocation', isError: undefined, message: [] },
      ];
      if (this.isBtj) {
        if (this.selectedWarehouseId) {
          return tireStoringContractService.getByWarehouseAndStatus(request, this.selectedWarehouseId, ContractStatusEnum.IN_WAREHOUSE, this.searchByQrCode)
            .then((res) => {
              if (res.data.items && res.data.totalRows && this.tableSetting) {
                this.tableSetting.totalRows = res.data.totalRows;
                const result = res.data.items;
                result.forEach((e: any) => {
                  e['isEdit'] = false;
                  e['errors'] = errors;
                  e['locationNo'] = (e.rackLocation || "") + " " + (e.columnLocation  || "") + " " + (e.rowLocation || "");
                })
                return result || [];
              }
            });
        } else {
          return tireStoringContractService.getByStatus(request, ContractStatusEnum.IN_WAREHOUSE, this.searchByQrCode)
            .then((res) => {
              if (res.data.items && res.data.totalRows && this.tableSetting) {
                this.tableSetting.totalRows = res.data.totalRows;
                const result = res.data.items;
                result.forEach((e: any) => {
                  e['isEdit'] = false;
                  e['errors'] = errors;
                  e['locationNo'] = (e.rackLocation || "") + " " + (e.columnLocation  || "") + " " + (e.rowLocation || "");
                })
                return result || [];
              }
            });
        }     
      } else {
        return tireStoringContractService.getByStatus(request, this.status, this.searchByQrCode)
          .then((res) => {
            if (res.data.items && res.data.totalRows && this.tableSetting) {
              this.tableSetting.totalRows = res.data.totalRows;
              const result = res.data.items;
              result.forEach((e: any) => {
                e['isEdit'] = false;
                e['errors'] = errors;
                e['locationNo'] = (e.rackLocation || "") + " " + (e.columnLocation  || "") + " " + (e.rowLocation || "");
              })
              return result || [];
            }
          });
      }
    });
    this.tableSetting = SearchContractDataTableSetting.init('slipNo', 'desc', this.tableFields, this.getItems, false);
    this.tableSetting.rowClickFunction = ((item: TireStoringContract) => this.goToDetail(item.id));
    this.tableSetting.onContractMatched = (id: string) => this.goToDetail(id);
    if (this.isBtj) {   
      this.findWarehouse();
    }
  }

  private findWarehouse(filter?: string) {
    warehouseService.findByName(filter)
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          this.listWarehouse = res.data.data;
        }
      });
  }

  private goBack() {
    this.$router.push({ name: 'routes.home' });
  }

  private goToDetail(id?: string) {
    if (id) {
      this.$router.push({ 
        name: 'routes.tire_contract_detail',
        params: { id },
      });
    } 
  }

  private changeStatus(status: number) {
    this.status = status;
    this.searchText = '';
    this.tableSetting.filter = '';
    (this.$refs.dataTable as any).refreshTable();
  }

  private onSelectWarehouseChange() {
    this.searchText = '';
    this.tableSetting.filter = '';
    this.tableSetting.currentPage = 1;
    (this.$refs.dataTable as any).refreshTable();
  }

  private scanQrCode() {
    this.showQrcodeReader = true;
  }

  private scanLocationQrCode() {
    this.showContractQrCodeReader = true;
  }

  private onDecode(result: string) {
    this.showQrcodeReader = false;
    if (result && this.tableSetting) {
      this.searchText = result;
      this.searchByQrCode = true;
      this.search();
    }
  }

  private onChangeSearchText() {
    this.searchByQrCode = false;
  }

  private search() {
    this.tableSetting.filter = this.searchText;
  }

  private getStatus(status: number): string {
    const currentStatus = this.statusOptions.find((option) => option.value === status);
    return (currentStatus && currentStatus.text) ? currentStatus.text : '';
  }

  private clearData() {
    this.status = 0;
    this.selectedWarehouseId = null;
    this.onSelectWarehouseChange();
  }

  private updateLocationNo(tireContract: any, dataTable: any) {
    const errors: InputError[] = [
      { field: 'rackLocation', isError: undefined, message: [] },
      { field: 'columnLocation', isError: undefined, message: [] },
      { field: 'rowLocation', isError: undefined, message: [] },
    ];
    locationService.checkExist({
      shelf1: tireContract.rackLocation,
      shelf2: tireContract.columnLocation,
      shelf3: tireContract.rowLocation
    } as Location
    ).then((res) =>{
      if(res.data.data){
        tireStoringContractService
        .updateLocationNo(tireContract)
        .then((res) => {
          if(res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
            toastService.success(this.$t('view.tire_register.message.contract_updated').toString() + res.data.data.slipNo);
            const item =  dataTable.find((e: any) => e.id === tireContract.id);
            item['isEdit'] = false;
          }
        })
        .catch((error) => {
          if (error.response.status === 400) {
            error.response.data.errors.forEach((err: any) => {
              const inputError = errors.find((e) => e.field === err.field);          
              if (inputError !== undefined) {
                if (inputError.isError === undefined) {
                  inputError.isError = false;
                  inputError.message = [];
                }
                inputError.message.push(err.defaultMessage);
              }
            });
            dataTable.forEach((e: any) => {
              if(e.id === tireContract.id) {
                e.errors = errors;
              }
            })
          }
        });
      }else {
        toastService.errorMessage('common.message.tire_location_not_exist');
      }
    })
  }

  private onDecodeTire(result: string) {
    if(result && !this.scannedContractIds.includes(result)) {
      this.scannedContractIds.push(result);
    }

    this.showContractConfirmModal = true
  }
  private onDecodeLocation(result: string) {
    if(result) {
      this.scannedLocationIds.push(result)
    }
    locationService.get(this.scannedLocationIds[0]).then((res:any) => {
      if(res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data){
        this.scannedLocation = res.data.data;
        this.showFinalConfirmModal = true;
        this.showLocationQrCodeReader = false;
      } else {
        toastService.errorMessage('common.message.tire_location_not_exist');
      }
    })
  }

  private handleReturnLocationQR() {
    this.showLocationQrCodeReader = false;
    this.showContractQrCodeReader = true;
  }

  private handleReturnTireQrCode() {
    this.showContractQrCodeReader  = false;
  }

  private settingLocation() {
    // this.loadSelectedContract( this.scannedTires);
    
    this.showContractConfirmModal = false;
    this.showContractQrCodeReader = false;
    this.showLocationQrCodeReader = true;
  }

  private cancelSetting() {
    this.showFinalConfirmModal = false;
    this.showContractQrCodeReader = true;
    this.scannedContractIds = [];
    this.scannedLocationIds = [];
    this.scannedLocation = new Location();
  }
  private saveSetting() {
    tireStoringContractService.settingLocation(this.scannedLocationIds[0], this.scannedContractIds).then((res: any) => {
      if(res.data.code === ResponseCodeEnum.CODE_SUCCESS) {
        const message = this.$t('view.tire_register.message.contract_updated').toString();
        const dataString = res.data.data && res.data.data.length > 0 ? res.data.data.join(', ') : '';
        toastService.success(message + dataString);
        this.showFinalConfirmModal = false;
        (this.$refs.dataTable as any).refreshTable();
        this.scannedContractIds = [];
        this.scannedTires = [];
        this.scannedLocationIds = [];
        this.scannedLocation = new Location();
      }
    })
  }
  // private loadSelectedContract(scannedTireIds: string[]) {
  //   if (!scannedTireIds) {
  //     return;
  //   }
  //   tireStoringInfoService.getSelectedContractByOneTireIds(scannedTireIds)
  //     .then((res) => {
  //       if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
  //         const selectedContractIds: string[] = res.data.data;
  //         this.scannedContractIds = selectedContractIds;
  //       }
  //     });
  // }

}
